module.exports = __webpack_public_path__ + "static/media/add-user.957070b7.png";